/* eslint-disable */
import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styles from "../../assets/css/modules/myprofile/myprofilecontactprefs.css";
import PreferenceRequired from '../shared/PreferenceRequired';
import SSOContainer from "../shared/containers/SSOContainer";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import { Paths } from "../../constants/UrlConstants";
import { isGDPRSet } from "../../services/PersonConsent";
import OnboardingContactPreferenceSection from "../shared/OnboardingContactPreferenceSection";
import {
  updateContactPreferences,
  saveContactPreferences,
  loadOptionValues,
  setIsValueChanged   
} from "../../actions/policy/policyActions";
import InternalViewButton from "../shared/buttons/InternalViewButton";
import contactPreferenceStyles from "../../assets/css/modules/preference/contact-preferences.css";
import OnBoardingLogout from "../../components/logout/OnboardingLogOut";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";

export const mapStateToProps = ({ policyReducer = {}, preferenceReducer = {},onboardingReducer={},layoutReducer ={} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const isInternalView =
    policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView;
  return {
    Layout: layoutReducer.layout,
    onboardingFlag :onboardingReducer.isUserOnboarding,
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    Members: selectedPolicy && selectedPolicy.Members,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    isInternalView,
    disabled:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView,
    contactPreferencekeys: preferenceReducer.contactPreferencekeys,
    contactValue: preferenceReducer.contactValue,
    communicationValue: preferenceReducer.communicationValue,
    saveCommunicationPref: preferenceReducer.saveCommunicationPref,
    saveContactPref: preferenceReducer.saveContactPref,
    isElgibleCustomised: preferenceReducer.isElgibleCustomised,
    HasMultiplePolicies:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.HasMultiplePolicies,
  };
};

const parent={
  display:'flex',
};
 

const child ={
  float: 'left',
};
const childLink ={
  float: 'left',
  padding:'8px',
}; 

 
 

const mapDispatchToProps = (dispatch) => {
  return {
    saveContactPreferences: (membershipNumber, updateContactPreferences) =>
      dispatch(saveContactPreferences(membershipNumber, updateContactPreferences)),
    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),
    setIsValueChanged: (Value) => dispatch(setIsValueChanged(Value)),
    updateContactPreferences: (
      membershipNumber,
      personConsent,
      history,
      redirectionNotRequired
    ) =>
      dispatch(
        updateContactPreferences(
          membershipNumber,
          personConsent,
          history,
          redirectionNotRequired
        )
      )
  };
};

export class ContactPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PersonConsent: props.PersonConsent,
      shownErrors: null,
      shownContactErrors: false,
      preferenceErrors: false,
      preferenceUpdateSuccess: false,
      contactPreferenceUpdateSucceeded: false,
      contactPrefsUpdateSucceeded: false,
      updateContactPreferences: null,
      MemberName: null,
      noSelectionError: false,
      IsOnChange: false,
      noChangesError: false,
    };
    this.onContactPreferenceSubmit = this.onContactPreferenceSubmit.bind(this);
    this.onSkipClick = this.onSkipClick.bind(this);
  }

  onSkipClick(e) {
      e.preventDefault();
      var consent = Object.assign({}, this.props.PersonConsent);
      this.setState({
        PersonConsent: consent
      });
      if(this.props.communicationValue ===null && this.props.onboardingFlag) {
        this.props.history.push(Paths.HomeCommunicationSupportNeeds);
      }
      else if(!isGDPRSet(this.props.PersonConsent)){
        this.props.history.push(Paths.PersonConsent);
      }
      else if(this.props.onboardingFlag){
        this.props.history.push(Paths.DocumentPreference);
      }
      else{
        this.props.history.push(Paths.HomeRoot);
      }
  }

  componentDidMount() {
    if (this.props.Members !== null && this.props.Members !== undefined) {
      let loggedInMember = this.props.Members.find((val) => val.IsLoggedInMember === true);
      if (loggedInMember !== null && loggedInMember !== undefined) {
        this.setState({ MemberName: loggedInMember.FullName });
      }
    }
  }

  onContactPreferenceSubmit(e) {
    e.preventDefault();
    this.props.setIsValueChanged(false);
    if (this.state.updateContactPreferences !== null &&
      this.state.updateContactPreferences.length !== 0 ) {
      this.setState({
        shownContactErrors: false,
        noSelectionError: false,
        contactPrefsUpdateSucceeded: false,
        IsOnChange: false,
        noChangesError: false,
      });

      this.props
        .saveContactPreferences(
          this.props.MembershipNumber,
          this.state.updateContactPreferences,
        )
        .then(() => {          
          if (this.props.saveContactPref !== null &&
            this.props.saveContactPref !== undefined &&
            this.props.saveContactPref !== false) {
            if(this.props.communicationValue ===null && this.props.onboardingFlag) {
              this.props.history.push(Paths.HomeCommunicationSupportNeeds);
            }
            else if(!isGDPRSet(this.props.PersonConsent)){
              this.props.history.push(Paths.PersonConsent);
            }
            else if(this.props.onboardingFlag){
              this.props.history.push(Paths.DocumentPreference);
            }
            else{
              this.props.history.push(Paths.HomeRoot);
            }
            this.props.loadOptionValues(this.props.MembershipNumber);
            this.setState({
              shownContactErrors: false,
              noSelectionError: false,
              contactPrefsUpdateSucceeded: true,
              IsOnChange: false,
              noChangesError: false,
            });
            
          }
          else {
            this.setState({
              shownContactErrors: true,
              noSelectionError: false,
              contactPrefsUpdateSucceeded: false,
              IsOnChange: false,
              noChangesError: false,
            });
          }
        });
    }
    else{
      if(this.props.communicationValue ===null && this.props.onboardingFlag) { 
        this.props.history.push(Paths.HomeCommunicationSupportNeeds);
      }
      else if(!isGDPRSet(this.props.PersonConsent)){
        this.props.history.push(Paths.PersonConsent);
      }
      else if(this.props.onboardingFlag){
        this.props.history.push(Paths.DocumentPreference);
      }
      else{
        this.props.history.push(Paths.HomeRoot);
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();

    this.setState({
      shownErrors: null,
      contactPreferenceUpdateSucceeded: false
    });

    this.props
      .updateContactPreferences(
        this.props.MembershipNumber,
        this.state.PersonConsent,
        this.props.history,
        true
      )
      .then(() => {
        if(this.props.communicationValue ===null && this.props.onboardingFlag) {
          this.props.history.push(Paths.HomeCommunicationSupportNeeds);
        }
        else if(!isGDPRSet(this.props.PersonConsent)){
          this.props.history.push(Paths.PersonConsent);
        }
        else if(this.props.onboardingFlag){
          this.props.history.push(Paths.DocumentPreference);
        }
        else{
          this.props.history.push(Paths.HomeRoot);
        }
        this.setState({
          shownErrors: null,
          contactPreferenceUpdateSucceeded: true
        });
      })
      .catch(() =>
        this.setState({
          shownErrors: Store.GDPR.ValidationErrors.ServerError,
          contactPreferenceUpdateSucceeded: false
        })
      );
  }


  render() {
    return (
      window?.axa?.features?.MFAFeature === "true"?
      <MFASSOContainer mfa={true}>
        <div className={styles.myProfileContactPreferencesmfa}>
          <div className={styles.pageContainer}>
            <PreferenceRequired isPreferenceRequired
              keys={this.props.contactPreferencekeys}
              values={this.props.contactValue}>
              {this.props.isElgibleCustomised === "true" 
              && this.props.personnotfound !== true &&
                (<div>
                  {(this.props.contactPreferencekeys !== null 
                    && this.props.contactValue !== undefined ? 
                    (<div className="row">                      
                    <div id="contactPreferenceSection" className="col-12">                                           
                      <h1 className={`axa-headline ${contactPreferenceStyles.titlesMFA}`}><Content
                        name={Store.MyProfileContactPreferences.ContactSection.HomeHeading}
                      /></h1>
                       
                      {this.state.shownContactErrors ?(
                        <div style={parent} className={
                          "alert alert-danger mt-2 " + styles.messages
                        }>
                        <div style={child}><Content name={Store.MyProfileContactPreferences.SaveContactPreferenceErrorOnboard} /></div>
                        <div style={childLink}><Link
                                  to="#"
                                  onClick={(e) => this.onSkipClick(e)}
                                  id="lnk-Skip"                                  
                                >
                                  SKIP
                                  <span className="mr-2 left-arrow-back">&#8594;</span>{" "}
                                </Link></div>
                      </div> 
                      ):null}
                       
                      <Content
                        name={Store.MyProfileContactPreferences.ContactSection.HomeSubheading}
                      />
                      <OnboardingContactPreferenceSection
                        contactPrefsKeys={this.props.contactPreferencekeys}
                        contactValue={this.props.contactValue}
                        MemberName={this.state.MemberName}
                        SaveContactPref={this.props.saveContactPref}
                        isContactValueChanged={(value) =>
                          this.setState({
                            IsOnChange: value
                          })}
                        updateContactPreferences={(contactprefs) =>
                          this.setState({
                            updateContactPreferences: contactprefs,
                            shownContactErrors: null,
                            contactPrefsUpdateSucceeded: false,
                            noSelectionError: false
                          })
                        }
                        mfa={true}
                        Zebrafied={true}
                        UseSlider={false}>
                      </OnboardingContactPreferenceSection>
                      <div id="personconsentMessage">                        
                        {this.state.noSelectionError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content name={Store.MyProfileContactPreferences.noSelectionContactPreferenceError} />
                          </div>
                        ) : null}                       
                        {this.state.noChangesError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content
                              name={
                                Store.MyProfileContactPreferences
                                  .NoChangesMessage
                              }
                            />
                          </div>
                        ) : null}
                      </div>
                      <form onSubmit={this.onContactPreferenceSubmit}>
                      
                        <div className={"row " + styles.contactSectionMFA}>
                          <div className="col-sm-12 text-center">
                            <button
                                label={Store.MyProfileContactPreferences.ContinueButton}
                                className={mfaStyles.buttonStart}
                                id="btn-contactPreference"
                                type="submit"
                                >{Store.MyProfileContactPreferences.ContinueButton}</button>                      
                          </div>                            
                        </div>
                        <div className={contactPreferenceStyles.boxContainer}>
                          <div className={this.props.Layout ==='MOL'? contactPreferenceStyles.contentContainerMOL : contactPreferenceStyles.contentContainer}>
                          { Store.MyProfileContactPreferences.AccountText}
                          </div>
                          <div className={contactPreferenceStyles.logoutContainer}>
                            <OnBoardingLogout/>
                          </div>
                        </div>                                
                      </form>
                    </div>
                               
                  </div>) :
                    (<div
                      className={
                        "alert alert-danger mt-2 " + styles.messages
                      }
                      role="alert"
                    >
                      <Content
                        name={
                          Store.MyProfileContactPreferences.Errors.GetMasterDataFailed
                        }
                      />
                    </div>))}
                </div>)}
            </PreferenceRequired>

          </div>
        </div>
      </MFASSOContainer>:
      <SSOContainer>
        <div className={styles.myProfileContactPreferences}>
          <div className={styles.pageContainer}>
            <PreferenceRequired isPreferenceRequired
              keys={this.props.contactPreferencekeys}
              values={this.props.contactValue}>
              {this.props.isElgibleCustomised === "true" 
              && this.props.personnotfound !== true &&
                (<div>
                  {(this.props.contactPreferencekeys !== null 
                    && this.props.contactValue !== undefined ? 
                    (<div className="row">                      
                    <div id="contactPreferenceSection" className="col-12">                                           
                      <h1 className={`axa-headline ${contactPreferenceStyles.title}`}><Content
                        name={Store.MyProfileContactPreferences.ContactSection.HomeHeading}
                      /></h1>
                       
                      {this.state.shownContactErrors ?(
                        <div style={parent} className={
                          "alert alert-danger mt-2 " + styles.messages
                        }>
                        <div style={child}><Content name={Store.MyProfileContactPreferences.SaveContactPreferenceErrorOnboard} /></div>
                        <div style={childLink}><Link
                                  to="#"
                                  onClick={(e) => this.onSkipClick(e)}
                                  id="lnk-Skip"                                  
                                >
                                  SKIP
                                  <span className="mr-2 left-arrow-back">&#8594;</span>{" "}
                                </Link></div>
                      </div> 
                      ):null}
                       
                      <Content
                        name={Store.MyProfileContactPreferences.ContactSection.HomeSubheading}
                      />
                      <OnboardingContactPreferenceSection
                        contactPrefsKeys={this.props.contactPreferencekeys}
                        contactValue={this.props.contactValue}
                        MemberName={this.state.MemberName}
                        SaveContactPref={this.props.saveContactPref}
                        isContactValueChanged={(value) =>
                          this.setState({
                            IsOnChange: value
                          })}
                        updateContactPreferences={(contactprefs) =>
                          this.setState({
                            updateContactPreferences: contactprefs,
                            shownContactErrors: null,
                            contactPrefsUpdateSucceeded: false,
                            noSelectionError: false
                          })
                        }
                        Zebrafied={true}
                        UseSlider={false}>
                      </OnboardingContactPreferenceSection>
                      <div id="personconsentMessage">                        
                        {this.state.noSelectionError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content name={Store.MyProfileContactPreferences.noSelectionContactPreferenceError} />
                          </div>
                        ) : null}                       
                        {this.state.noChangesError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content
                              name={
                                Store.MyProfileContactPreferences
                                  .NoChangesMessage
                              }
                            />
                          </div>
                        ) : null}
                      </div>
                      <form onSubmit={this.onContactPreferenceSubmit}>
                      
                        <div className={"row " + styles.contactSection}>
                          <div className="col-sm-12 text-center">
                            <InternalViewButton
                              id="btn-contactPreference"
                              type="submit"
                              className="form-control btn btn-submit"
                            //  disabled={this.props.disabled}
                              label={
                                Store.MyProfileContactPreferences.ContinueButton
                              }
                              btntype="homeButton"
                            />                            
                          </div>                            
                        </div>
                        <div className={contactPreferenceStyles.boxContainer}>
                          <div className={this.props.Layout ==='MOL'? contactPreferenceStyles.contentContainerMOL : contactPreferenceStyles.contentContainer}>
                          { Store.MyProfileContactPreferences.AccountText}
                          </div>
                          <div className={contactPreferenceStyles.logoutContainer}>
                            <OnBoardingLogout/>
                          </div>
                        </div>                                
                      </form>
                    </div>
                               
                  </div>) :
                    (<div
                      className={
                        "alert alert-danger mt-2 " + styles.messages
                      }
                      role="alert"
                    >
                      <Content
                        name={
                          Store.MyProfileContactPreferences.Errors.GetMasterDataFailed
                        }
                      />
                    </div>))}
                </div>)}
            </PreferenceRequired>

          </div>
        </div>
      </SSOContainer>
    );
  }
}

 
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactPreferences);

